import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography'

import { Result, Setup } from './Index'
import { updateBestTeachingAwardParams } from '../../actions'
const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginTop: theme.spacing(5),

    [theme.breakpoints.up(1000 + theme.spacing(2) * 2)]: {
      width: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  stepper: {
    padding: theme.spacing(3, 0, 5)
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  }
}))

const steps = ['Setup', 'View Result']

function getStepContent(step) {
  switch (step) {
    case 0:
      return <Setup />
    case 1:
      return <Result />
    default:
      throw new Error('Unknown step')
  }
}

function BestTeachingAwardReportHome(props) {
  const classes = useStyles()
  const { data } = props
  const history = useHistory();
  const [activeStep, setActiveStep] = React.useState(0)

  const handleConfigure = async () => {
    history.push('/best-teaching-award-import')
  }

  const handleNext = async () => {
    if (activeStep === 0) {
      let payload = {
        courseType: data.courseType,
        campus: data.campus
      }

      setActiveStep(activeStep + 1)

      updateBestTeachingAwardParams(payload)
    } else {
      setActiveStep(activeStep + 1)
    }
  }

  const handleBack = () => {
    let progreess = activeStep - 1
    setActiveStep(progreess)
  }

  return (
    <>
      <Typography component='h1' variant='h5' align='center'>
        {' '}
        Best Teaching Award Report
      </Typography>

      <Stepper activeStep={activeStep} className={classes.stepper}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length ? (
        <div> final </div>
      ) : (
        <>
          {getStepContent(activeStep)}

          <div className={classes.buttons}>
            {activeStep === 0 && (
              <Button
                variant='contained'
                color='primary'
                onClick={handleConfigure}
                className={classes.button}
              >
                Configure
              </Button>
            )}
            {activeStep !== 0 && (
              <Button
                onClick={handleBack}
                className={classes.button}
                color='secondary'
              >
                Back
              </Button>
            )}
            {activeStep < steps.length - 1 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={handleNext}
                className={classes.button}
              >
                {'Next'}
              </Button>
            ) : null}
          </div>
        </>
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    data: state.BestTeachingAwardReport
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadBestTeachingAwardData: (payload) => {
    dispatch(loadBestTeachingAwardData(payload))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BestTeachingAwardReportHome)
